import { render } from "./LoadingBookCarousel.vue?vue&type=template&id=0c63878f&scoped=true"
const script = {}

import "./LoadingBookCarousel.vue?vue&type=style&index=0&id=0c63878f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c63878f"]])

export default __exports__